// crypto.randomUUID is missing on older Android WebViews (Chrome < 92) and in
// insecure contexts, while crypto.getRandomValues is supported far more widely.
export function randomUuidCompat(): string {
	if (typeof crypto.randomUUID === "function") {
		return crypto.randomUUID();
	}
	return randomUuidFromRandomValues();
}

function randomUuidFromRandomValues(): string {
	const bytes = crypto.getRandomValues(new Uint8Array(16));
	// RFC 4122 section 4.4: set version to 4 and variant to 10xx
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;

	const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
	return [
		hex.slice(0, 4).join(""),
		hex.slice(4, 6).join(""),
		hex.slice(6, 8).join(""),
		hex.slice(8, 10).join(""),
		hex.slice(10, 16).join(""),
	].join("-");
}
